// const path = 'http://192.168.0.49:4000'
// const path = 'https://test.iventos.tv'
const path = 'https://spica.es'

module.exports = {
    path,
}
